/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import ProgressPanelMessage from './ProgressPanelMessage';

type Props = {
	resolver: () => Promise<Component>;
	children: (c: Component) => Component;
};

@observer
export default class Loadable extends Component<Props, any> {
	static propTypes = {
		resolver: PropTypes.func.isRequired,
		children: PropTypes.func.isRequired,
	};

	state = {
		ResolvedComponent: null,
	};

	componentDidMount() {
		this.props.resolver().then(Comp => {
			this.setState({ ResolvedComponent: Comp });
		});
	}

	render() {
		const { ResolvedComponent } = this.state;

		return ResolvedComponent ? (
			this.props.children(ResolvedComponent)
		) : (
			<ProgressPanelMessage />
		);
	}
}
